var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('mdb-row',[_c('mdb-col',{staticClass:"mb-4",attrs:{"lg":"6"}},[_c('mdb-card',[(_vm.withHeader)?_c('mdb-card-header',[_vm._v(_vm._s(_vm.componentHeader))]):_vm._e(),_c('mdb-card-body',[_vm._t("default")],2)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }